module.exports = __webpack_public_path__ + "media/images/members/fernando_rodriguez_gallego_lopez-9a6f1ab3e65e576ade886f58ac8e03b2.jpg";